'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SettingConstants = undefined;

var _keymirror = require('keymirror');

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingConstants = exports.SettingConstants = (0, _keymirror2.default)({
    SET_SETTING: null,

    LOAD_SETTINGS: null,
    LOAD_SETTINGS_SUCCESS: null,
    LOAD_SETTINGS_FAIL: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/setting.js
// module id = 1880
// module chunks = 0